//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import locationReports from '~/graphql/queries/locationReports';

export default {
  props: {
    location: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    reports: [],
  }),
  mounted() {
    if (this.location.uuid) {
      this.$apollo.query({
        query: locationReports,
        variables: {
          uuid: this.location.uuid,
        },
      }).then((data) => {
        this.reports = data.data.locationReports;
      });
    }
  },
};
